import * as actionTypes from "./actionTypes";
import { defaultFilters, defaultPageParams } from "../../constants";

export const reducerInitialState = {
  initializing: true,
  loading: false,
  pageParams: {
    ...defaultPageParams
  },
  providerPanels: [],
  meta: {
    page: 1,
    perPage: 50,
    total: 0,
  },
  filters: {
    ...defaultFilters
  },
  error: null,
};

export default (state, action) => {
  switch (action.type) {
    case actionTypes.FETCH_PROVIDER_PANELS_PENDING:
      return {
        ...state,
        ...action.payload,
        loading: true,
      };
    case actionTypes.FETCH_PROVIDER_PANELS_FAILED:
      return {
        ...state,
        loading: false,
        error: action.payload.error,
      };
    case actionTypes.FETCH_PROVIDER_PANELS_SUCCEEDED:
      return {
        ...state,
        loading: false,
        ...action.payload,
      };
    case actionTypes.UPDATE_PAGE_PARAMS:
      return {
        ...state,
        pageParams: {
          ...state.pageParams,
          ...action.payload,
        },
      };
    case actionTypes.UPDATE_FILTERS:
      return {
        ...state,
        pageParams: {
          ...state.pageParams,
          page: 1,
        },
        filters: {
          ...state.filters,
          ...action.payload,
        },
      };
    case actionTypes.RESET_FILTERS:
      return {
        ...state,
        pageParams: {
          ...defaultPageParams,
        },
        filters: {
          ...defaultFilters,
        },
      };
    case actionTypes.INITIALIZE_COMPONENT:
      return {
        ...state,
        initializing: false,
        pageParams: {
          ...state.pageParams,
          ...action.payload.pageParams,
        },
        filters: {
          ...state.filters,
          ...action.payload.filters,
        },
      };
    default:
      return state;
  };
};
